type GiftItem = {
  id: string | number;
  name: string;
  quantity: number;
};

export type GiftInvoiceData = {
  id: number;
  phone: string;
  date: string;
  time: string;
  items: GiftItem[];
};

/**
 * Minimal 58mm gift invoice template.
 * Header: "فاتورة هدية" + phone + date/time + items table + thank you footer.
 */
import LogoArSvg from "@/components/LogoArSvg";

const InvoiceGift = ({ data }: { data: GiftInvoiceData }) => {
  return (
    <div
      dir='rtl'
      style={{
        width: "58mm",
        padding: "0",
        background: "#fff",
        color: "#000",
        margin: "0 auto",
        border: "none",
        borderRadius: "8px",
        fontFamily: "Tahoma, Arial, sans-serif",
        fontSize: "14px",
      }}
    >
      <style>{`
        *, *:focus { outline: none !important; -webkit-tap-highlight-color: transparent !important; }
        @media print {
          * { font-size: 14px !important; color: black !important; outline: none !important; -webkit-tap-highlight-color: transparent !important; }
          table, th, td { border: 1px dashed #000 !important; }
          body { margin: 0 !important; padding: 0 !important; background: white !important; }
        }
        .header { text-align: center; margin-bottom: 8px; }
        .header .title { font-weight: bold; font-size: 20px; }
        .items-table { width: 100%; border-collapse: collapse; table-layout: fixed; font-size: 14px !important; margin-top: 6px; }
        .items-table th { border: 1px dashed #000; padding: 3px; font-size: 10px !important; text-align: center; background: #fff; font-weight: 600; }
        .items-table td { border: 1px dashed #000; padding: 3px; font-size: 14px !important; text-align: center; }
        .footer { margin-top: 12px; text-align: center; font-size: 11px; }
        .wrap { white-space: normal; word-break: break-word; overflow: visible; line-height: 1.4; }
      `}</style>

      <div className='header'>
        {/* Logo (inline SVG for WebView compatibility) */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 6,
            marginTop: 10,
          }}
        >
          <LogoArSvg style={{ maxHeight: 48, height: 48 }} />
        </div>
        <div className='title'>فاتورة هدية</div>
        <div style={{ marginTop: 6 }}>رقم الجوال: {data.phone || "-"}</div>
        <div style={{ marginTop: 4 }}>
          التاريخ: {data.date} - {data.time}
        </div>
      </div>

      <table className='items-table'>
        <thead>
          <tr>
            <th>المنتج</th>
            <th>الكمية</th>
          </tr>
        </thead>
        <tbody>
          {(data.items || []).map((it) => (
            <tr key={it.id}>
              <td className='wrap'>
                {String(it.name)
                  .split(/\s+/)
                  .map((word, idx) => (
                    <span key={idx} style={{ display: "block" }}>
                      {word}
                    </span>
                  ))}
              </td>
              <td>{it.quantity}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className='footer'>
        <p>{"<شكرا لاستخدامكم خدمتنا>"}</p>
      </div>
    </div>
  );
};

export default InvoiceGift;
